import { render, staticRenderFns } from "./control-tabs.vue?vue&type=template&id=a1f4217e"
import script from "./control-tabs.vue?vue&type=script&lang=ts"
export * from "./control-tabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports